import {useContext} from 'react';
import {AuthContext} from 'contexts/auth';

export default function useAuth() {
  const value = useContext(AuthContext);
  return value;
}
